export default __webpack_public_path__ + "static/Personen_Schatten_Parallax-7ed83536401adc8938b97f5ad230d00d.jpg";